module.exports = __webpack_public_path__ + "static/img/Parametric Studies 1 - First steps in ExoOPS.9ce3677.png";